import { useEffect, useRef } from "react";

/**
 * VoiceTranscript — elegant, minimal, scrollable transcript panel.
 * Auto-scrolls to the newest message. Shows a `AURI is composing…` placeholder
 * for streaming assistant turns.
 */
export default function VoiceTranscript({ messages, state }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current) ref.current.scrollTop = ref.current.scrollHeight;
  }, [messages, state]);

  return (
    <div
      ref={ref}
      className="voice-transcript"
      data-testid="voice-transcript"
      aria-live="polite"
      aria-atomic="false"
    >
      {messages.length === 0 && (
        <div className="voice-transcript__empty">
          <span>Say hello to begin — I&rsquo;m listening.</span>
        </div>
      )}
      {messages.map((m, i) => (
        <div
          key={i}
          className={`voice-transcript__row voice-transcript__row--${m.role}`}
          data-role={m.role}
        >
          <span className="voice-transcript__label">
            {m.role === "user" ? "You" : "AURI"}
          </span>
          <span className="voice-transcript__text">{m.text || (m.role === "assistant" && !m.final ? "…" : "")}</span>
        </div>
      ))}
      {state === "thinking" && (
        <div className="voice-transcript__row voice-transcript__row--assistant voice-transcript__row--pending">
          <span className="voice-transcript__label">AURI</span>
          <span className="voice-transcript__text voice-transcript__pending">is composing…</span>
        </div>
      )}
    </div>
  );
}
